// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3a0b9","content":"Consent_content__T0Y0o","footer":"Consent_footer__1UTSB"};